export class ApolloError extends Error {
    constructor(options) {
        super(options.message || 'GraphQL error');
        this.name = 'ApolloError';
        this.graphQLErrors = options.graphQLErrors || [];
        this.networkError = options.networkError;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApolloError);
        }
    }
}
